import { formatBytes } from '@atlas/ui-domain'
import { ChevronRight } from 'lucide-react'
import { DESIGN_TILE_GRID, DesignFileTile } from './DesignFileTile'

/** What a listed design file needs to show. */
export interface DesignFileItem {
	fileId: string
	fileName: string
	contentType?: string
	fileSize?: number | null
	thumbnailUrl?: string
}

export interface DesignFilesListProps {
	active: readonly DesignFileItem[]
	inactive: readonly DesignFileItem[]
	onDownload: (fileId: string) => void
}

function Tiles({ files, onDownload }: { files: readonly DesignFileItem[]; onDownload: (fileId: string) => void }) {
	return (
		<ul className={DESIGN_TILE_GRID}>
			{files.map((file) => (
				<DesignFileTile
					key={file.fileId}
					name={file.fileName}
					contentType={file.contentType}
					thumbnailUrl={file.thumbnailUrl}
					detail={formatBytes(file.fileSize ?? null)}
					onDownload={() => onDownload(file.fileId)}
				/>
			))}
		</ul>
	)
}

/** The order's submitted design, then the files earlier rounds replaced, collapsed. Read-only. */
export function DesignFilesList({ active, inactive, onDownload }: DesignFilesListProps) {
	return (
		<div className="space-y-3">
			{active.length ? (
				<Tiles files={active} onDownload={onDownload} />
			) : (
				<p className="text-ds-sm text-ds-text-muted">No design submitted yet.</p>
			)}
			{inactive.length ? (
				<details className="group">
					<summary className="flex cursor-pointer list-none items-center gap-1 text-ds-sm text-ds-text-muted hover:text-ds-text">
						<ChevronRight className="h-4 w-4 transition-transform group-open:rotate-90" aria-hidden />
						Inactive files · {inactive.length}
					</summary>
					<div className="mt-3">
						<Tiles files={inactive} onDownload={onDownload} />
					</div>
				</details>
			) : null}
		</div>
	)
}
